export const TIMESTAMP_TYPE_CREATED_AT = 'createdAt';
export const TIMESTAMP_TYPE_UPDATED_AT = 'updatedAt';
